<template>
  <div>
    <h1>Conundrum Settings</h1>
  </div>
</template>

<script>
export default {
  name: 'ConundrumSettings',
}
</script>